import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { Reveal } from "@/components/Reveal";
import { solutions } from "@/data/solutions";

export default function SolutionsHub() {
  return (
    <PageLayout
      seoTitle="Cybersecurity Solutions by Organization Type | Aliwer"
      seoDescription="Cybersecurity solutions tailored to your organization: small & midsize business, regulated organizations, cloud-first, and AI-enabled teams."
      path="/solutions"
      eyebrow="Solutions"
      title="Security, tailored to how you operate."
      subtitle="Choose the path that fits your organization — each solution combines the right assessments, engineering, and managed protection."
      testid="solutions-hub"
    >
      <div className="space-y-5" data-testid="solutions-rows">
        {solutions.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.ShieldCheck;
          const reversed = i % 2 === 1;
          return (
            <Reveal key={s.slug} delay={i * 0.04}>
              <Link
                to={`/solutions/${s.slug}`}
                data-testid={`solution-card-${s.slug}`}
                className={`group flex flex-col md:items-center gap-6 md:gap-10 rounded-2xl border border-white/10 bg-surface p-8 md:p-10 hover:bg-[#232326] transition-colors duration-500 ${
                  reversed ? "md:flex-row-reverse" : "md:flex-row"
                }`}
              >
                <div className={`md:w-[30%] flex items-center gap-5 md:gap-0 md:flex-col md:items-start ${reversed ? "md:items-end md:text-right" : ""}`}>
                  <span className="font-display text-5xl md:text-6xl tracking-tighter text-fog/30">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Icon size={26} className="text-paper md:mt-5" strokeWidth={1.2} />
                </div>
                <div className="flex-1">
                  <h2 className="font-display text-2xl sm:text-3xl tracking-tight text-paper mb-3">{s.title}</h2>
                  <p className="text-sm text-fog leading-relaxed max-w-2xl">{s.card}</p>
                  <span className="mt-5 inline-flex items-center gap-1 text-xs uppercase tracking-widest text-paper">
                    Explore this path
                    <Icons.ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </PageLayout>
  );
}
